import styles from './styles/HouseManagerProfile.module.css';
import useReviews from './hooks/useReviews';
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar  } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom"


export default function ReviewsSection() {
    const { reviews } = useReviews();

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 2;

    const indexOfLastReview = currentPage * itemsPerPage;
    const indexOfFirstReview = indexOfLastReview - itemsPerPage;
    const currentReview = reviews.slice(indexOfFirstReview, indexOfLastReview);


    return (
        <>

            <div className={styles.reviewSection}>
            <h2>Reviews</h2>
            <div className={styles.subSection}>
            {reviews.length > 0 ? (
                <>
                {currentReview.map((review) => (
                    <div key={review.id} className={styles.review}>
                    <p><FontAwesomeIcon icon={faStar} style={{color: 'orange'}}/> ({review.rating.toFixed(1)}/5)</p>
                    <p>{review.comment}</p>
                    <small>{new Date(review.created_at).toLocaleDateString()}</small> by <Link
                            to={`/profile/employer/${review.reviewer_id}`}
                            key={review.id}
                            className={styles.resultCard}
                        >
                            <strong>{review.reviewer_username}</strong>
                        </Link>
                    </div>
                ))}
                </>
                
            ) : (
                <p>No Reviews Yet!</p>
            )}
            </div>
            <div className={styles.pagination}>
                <button 
                    className={styles.pageButton}
                    onClick={() => setCurrentPage((prev) => Math.max(prev-1, 1))}
                    disabled={currentPage === 1}
                    >
                    ◀ Previous
                </button>
                    <span className={styles.pageNumber}> Page {currentPage} </span>
                <button 
                    className={styles.pageButton}
                    onClick={() => setCurrentPage((prev) =>(prev * itemsPerPage < reviews.length ? prev + 1 : prev))}
                    disabled={indexOfLastReview >= reviews.length}
                    >
                    Next ▶
                </button>
            </div>
        </div>
            
        </>
        
         
    )
}